<ngx-spinner type="square-jelly-box">
  <h3>Loading...</h3>
</ngx-spinner>

@if (themeReady && ({offerStatus: offerConfirmationNew$ | async, error: offerErrors$ | async}); as data) {
  <div class="status-body">
    <div [hidden]="data.error ? true : false">
      @if (data.offerStatus) {
        <div class="status-wrapper">
          <mat-card class="status-card">
            <h4>Thank you for placing your upgrade requests!</h4>
            <p>The details of your request(s) are below:</p>

            <div class="status-info">
              <p><span>Property:</span> {{ data.offerStatus[0].prop_name | titlecase }}</p>
              <p><span>Confirmation Number:</span> {{ data.offerStatus[0].conf_num }}</p>
            </div>

            <div class="cart-table-wrapper">
              <app-shopping-cart-table
                [offers]="data.offerStatus"
                [offerAliasId]="offerAliasId"
                [propertyId]="propertyId"
                [displayRemovalButtons]="false"
                [displayStatus]="true">
              </app-shopping-cart-table>
            </div>

            <p class="status-footer-text">
              The property team will typically review and accept requests within 24 hours of submission
              and you will be notified via an email communication.
            </p>
          </mat-card>
        </div>
      }
    </div>
  </div>
}





